import { useCatalog } from '../../contexts/CatalogContext';
import { useSite } from '../../contexts/SiteContext';
import { tierIn } from '../../data/gifts';
import { euro } from '../../core/format/currency';

/** Snel vergelijken — vergelijkende inhoud hoort in een tabel. */
export function RoutineCompare({
  heading
}: {
  heading: string;
}) {
  const {
    routines,
    routineTotals
  } = useCatalog();
  const {
    giftTiers
  } = useSite();
  // Vergelijken kan pas vanaf twee protocollen; anders een tabel met één (of nul) rijen.
  if (routines.length < 2) return null;
  return <div className="mt-16 min-w-0" data-id="element-8318" data-mp="3dhfmwrf6se3q">
      <h3 id="routine-compare" className="type-title text-ink" data-id="element-8319" data-mp="3i9qnzxlny5xv">
        {heading}
      </h3>
      {/* Scrollbaar op mobiel; met het toetsenbord bereikbaar zodat je ook zonder muis kunt schuiven. */}
      <div className="-mx-6 mt-6 overflow-x-auto px-6 lg:mx-0 lg:px-0" tabIndex={0} role="region" aria-labelledby="routine-compare" data-id="element-8320" data-mp="3s7wnk8jzyzzk">
        <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-8321" data-mp="55mjukovafe">
          <caption className="sr-only" data-id="element-8322" data-mp="1ru55j8mpy1tv">{heading}: per protocol voor wie, hoe lang, welk cadeau en de prijs</caption>
          <thead data-id="element-8323" data-mp="1mu9ahyw01kqg">
            <tr className="border-b border-ink/25 text-[13px] text-muted" data-id="element-8324" data-mp="1mtpw2s5k5eh6">
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8325" data-mp="1hump3260oy6k">
                Protocol
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8326" data-mp="1cxeebmn77wfc">
                Voor wie
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8327" data-mp="2aisalr4war7g">
                Gaat mee
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8328" data-mp="25lilydpbyjko">
                Cadeau
              </th>
              <th scope="col" className="py-3 text-right font-normal" data-id="element-8329" data-mp="20sh5w2de0dzi">
                Prijs
              </th>
            </tr>
          </thead>
          <tbody data-id="element-8330" data-mp="2tabdzz2u07a0">
            {routines.map(r => {
            const t = routineTotals(r);
            const gift = tierIn(giftTiers, t.price);
            return <tr key={r.id} className="border-b border-line align-top text-[15px]" data-id="element-8331" data-mp="2oi1nagtw736o">
                  <th scope="row" className="py-4 pr-6 type-name font-normal text-ink" data-id="element-8332" data-mp="mofbb9mo1hzy">
                    {r.name}
                  </th>
                  <td className="py-4 pr-6 text-muted" data-id="element-8333" data-mp="cx18oszf422l">{r.forWho}</td>
                  <td className="whitespace-nowrap py-4 pr-6 text-muted" data-id="element-8334" data-mp="cuop6be0hjnf">{t.months}</td>
                  <td className="py-4 pr-6 text-muted" data-id="element-8335" data-mp="htj617sf4y4w">
                    {gift ? gift.title : <>
                        <span aria-hidden="true" data-id="element-8336" data-mp="7yzo23mcfup0">—</span>
                        <span className="sr-only" data-id="element-8337" data-mp="3q3b3eu5e9372">Geen cadeau</span>
                      </>}
                  </td>
                  <td className="whitespace-nowrap py-4 text-right type-name tabular-nums text-ink" data-id="element-8338" data-mp="3v2xfv1deefet">{euro(t.price)}</td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
}